<a [routerLink]="[routerLink]">
  <div [ngClass]="cardClass">
    <div class="card-body">
      <div class="px-3 py-3">
        <div class="media">
          <div class="media-body white text-left">
            <h3>{{ amount }}</h3>
            <span>{{ title }}</span>
          </div>
          <div class="media-right align-self-center">
            <i class="ft-repeat white font-large-2 float-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>
